<template>
  <header class="example-header hidden-print">
    <div class="header-top">
      <div class="container">
        <div class="logo">
          <div class="logo1">
            <router-link :to="{ name: 'Start' }" exact>
              <img
                src="/static/images/logo.png"
                width="117"
                height="61"
                border="0"
                alt="GS1 Germany Logo"
              />
            </router-link>
            <p class="large hidden-xs hidden-sm">
              <strong>{{ $t('title') }}</strong
              ><br />
              {{ $t('provided_by') }}
            </p>
          </div>
        </div>
        <div style="right: 0; position: absolute">
          <button
            @click="logout"
            class="btn btn-xs btn-secondary"
            style="margin-top: 15px"
            role="button"
            tag="button"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
    <div class="navigation">
      <div class="container">
        <nav class="navbar yamm navbar-default" role="navigation">
          <div class="navbar-header">
            <div class="logo1 visible-xs">
              <router-link :to="{ name: 'Start' }" exact>
                <img
                  src="/static/images/logo.png"
                  width="117"
                  height="61"
                  border="0"
                  alt="GS1 Germany Logo"
                />
              </router-link>
            </div>
            <button
              type="button"
              data-toggle="collapse"
              data-target="#navbar-collapse-example"
              class="navbar-toggle collapsed"
            >
              <span class="icon-bar"></span><span class="icon-bar"></span
              ><span class="icon-bar"></span>
            </button>
            <div class="secondary-nav">
              <button
                type="button"
                class="btn-primary logout-button"
                @click="logout"
              >
                Logout
              </button>
            </div>
          </div>
          <div id="navbar-collapse-example" class="navbar-collapse collapse">
            <ul class="nav navbar-nav">
              <router-link
                tag="li"
                :to="{ name: 'Start' }"
                exact
                :class="{
                  active:
                    $route.path.startsWith('/companies') ||
                    $route.path.startsWith('/result')
                }"
              >
                <a>{{ $t('menu.search') }}</a>
              </router-link>
              <router-link tag="li" :to="{ name: 'Token' }">
                <a>{{ $t('menu.token') }}</a>
              </router-link>
              <router-link tag="li" :to="{ name: 'Bulk' }">
                <a>{{ $t('menu.bulk') }}</a>
              </router-link>
              <li>
                <a
                  href="https://www.gs1-germany.de/serviceverzeichnis/verified-by-gs1/"
                  target="_blank"
                  rel="noopener"
                  >{{ $t('menu.about') }}</a
                >
              </li>
              <li>
                <LanguageSelector style="margin-top: 20px" />
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
    <div class="header-bottom visible-xs visible-sm">
      <div class="container">
        <strong>{{ $t('title') }}</strong
        ><br />
        {{ $t('provided_by') }}
      </div>
    </div>
  </header>
</template>

<script>
import LanguageSelector from './LanguageSelector.vue'
import { logout } from '../auth'

export default {
  name: 'Header',
  components: { LanguageSelector },
  methods: {
    logout
  },
  i18n: {
    messages: {
      de: {
        title: 'Verified by GS1',
        provided_by: 'provided by GS1 Germany',
        menu: {
          search: 'Suche',
          bulk: 'Mehrfachabfrage',
          about: 'Mehr über Verified by GS1 erfahren',
          token: 'API'
        }
      },
      en: {
        title: 'Verified by GS1',
        provided_by: 'provided by GS1 Germany',
        menu: {
          search: 'Search',
          bulk: 'Bulk search',
          about: 'About this service',
          token: 'API'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue